import { PureComponent, type ReactNode } from 'react';
import type { ConnectedProps } from 'react-redux';

import type { LoadOptionsResult } from '../../../select_field/utils';
import SelectFieldWrapper, {
  type SelectFieldWrapperProps,
} from '../select/select';
import connector from './connector';

type Props = ConnectedProps<typeof connector> & SelectFieldWrapperProps;

export class SelectApps extends PureComponent<Props> {
  cachedOptions: LoadOptionsResult | undefined;

  handleLoadOptions = async (): Promise<LoadOptionsResult> => {
    if (this.cachedOptions) {
      return this.cachedOptions;
    }

    const options = await this.props.getAllApps().then((apps) =>
      apps.map((object) => ({
        value: object.id,
        label: object.name,
      })),
    );
    this.cachedOptions = options;
    return options;
  };

  render(): ReactNode {
    const { getAllApps, ...props } = this.props;

    return (
      <SelectFieldWrapper
        {...props}
        preloadOptions
        loadOptions={this.handleLoadOptions}
      />
    );
  }
}

export default connector(SelectApps);
